import AsyncPage from 'pages/AsyncPage'

import universal from 'react-universal-component'
const component = universal(props => import('./ImportWordDocPage.js'))

export default new AsyncPage({
  title: 'compose.import.page_title',
  pageComponent: component
})
